import { connect } from 'react-redux'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { priceActions } from 'reduxModules/actions/PriceActions'

import { PricesBodyRowBase } from './PricesBodyRow'

import { styles } from './styles'

const mapDispatchToProps = {
  setPrice: priceActions.setPrice,
  changePrice: priceActions.changePrice
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)

export const PricesBodyRow = enhance(PricesBodyRowBase)


// WEBPACK FOOTER //
// ./src/components/Prices/components/PricesBodyRow/index.js